import type { BrowserOptions } from "@sentry/browser";

const SENSITIVE_KEYS = { deny: ["forwarded", "-ip", "remote-", "via", "-user"] };

// Sentry 11 collects user info, cookies and HTTP bodies when dataCollection is unset.
// These values keep the restrictive Sentry 10 defaults.
export const sentryDataCollection: NonNullable<BrowserOptions["dataCollection"]> = {
	userInfo: false,
	cookies: false,
	httpHeaders: { request: SENSITIVE_KEYS, response: SENSITIVE_KEYS },
	httpBodies: [],
	urlQueryParams: SENSITIVE_KEYS,
	genAI: { inputs: false, outputs: false },
	databaseQueryData: false,
	queues: false,
	graphQL: { document: false, variables: false },
};
